import { render } from "./PreviewComponent.vue?vue&type=template&id=479e288b&scoped=true&bindings={\"img\":\"props\",\"text\":\"props\"}"
import script from "./PreviewComponent.vue?vue&type=script&lang=js"
export * from "./PreviewComponent.vue?vue&type=script&lang=js"

import "./PreviewComponent.vue?vue&type=style&index=0&id=479e288b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-479e288b"

export default script